import { branchFeatureFlags } from "./branchFeatureFlags";

/**
 * Which applications a reviewer's list shows. "pending" keeps only the ones
 * waiting for that level to act on; "all" is the full list as it has always
 * been. The status lists for each level live on the backend in
 * api/config/pendingApplicationView.js, which reads this value from the
 * list and count requests.
 */
export type ApplicationListView = "pending" | "all";

/**
 * The view a list page opens in. With the feature off, the lists stay on
 * "all" and the switch button is hidden, so nothing changes for the user.
 */
export const DEFAULT_APPLICATION_LIST_VIEW: ApplicationListView =
  branchFeatureFlags.ENABLE_LEVEL_PENDING_VIEW ? "pending" : "all";

export const isPendingViewEnabled = (): boolean =>
  branchFeatureFlags.ENABLE_LEVEL_PENDING_VIEW;
